import React from 'react'
import ChartSwitch from './chart-switch'
import PatchLink from 'lib/components/patch-link'
import Icon from 'lib/components/icon'
import Select from 'lib/components/select'
import Tooltip from 'lib/components/tooltip'
import withSend from 'microcosm/addons/with-send'
import * as placeholder from 'lib/config/placeholder'

class ChartSelector extends React.PureComponent {
  onChange = e => {
    this.props.send('patchQuery', { [this.props.name]: e.target.value })
  }

  renderExpandedText() {
    const { query, options, config } = this.props

    const selected =
      options.find(opt => opt.text === query.expandedSelection) ||
      options.find(opt => opt.default)
    const trackChartName = selected ? selected.text.toLowerCase() : null

    const toolTipHTML = placeholder.replace(config.chartInfoText[selected.value])

    return (
      <div
        className="chart-container track-as-chart-name"
        data-track={trackChartName}
      >
        <div className="chart-container__menu">
          <div className="split-nav__main">
            <h3 className="chart-container__heading">{selected.text}</h3>
          </div>
          <div className="split-nav__aux">
            <PatchLink
              query={{ expanded: undefined, expandedSelection: undefined }}
            >
              <Icon type="collapse" height="20px" width="20px" />
              <span className="screenreader-only">Collapse chart</span>
            </PatchLink>
          </div>
        </div>
        <div
          className="chart-container__content"
          dangerouslySetInnerHTML={{ __html: toolTipHTML }}
        />
      </div>
    )
  }

  render() {
    const {
      query,
      selected,
      name,
      options,
      disableOptions,
      config,
      ...dataProps
    } = this.props

    if (query.expanded === name) {
      return this.renderExpandedText()
    }

    const toolTipHTML = placeholder.replace(config.chartInfoText[selected.value])
    const trackChartName = selected ? selected.text.toLowerCase() : null
    const expandedParams = {
      ...query,
      expanded: name,
      expandedSelection: selected.text
    }

    return (
      <div className="chart-container track-as-chart-name" data-track={trackChartName}>
        <div className="split-nav chart-container__menu">
          <div className="split-nav__main chart-selector">
            <Select
              disabled={disableOptions}
              labelFor={name}
              labelVisible={false}
              label="Chart Data"
              options={options}
              onChange={this.onChange}
              selected={selected.value}
              selectedText={selected.text}
            />
          </div>

          <div className="split-nav__aux">
            <Tooltip overlay={toolTipHTML}>
              <Icon type="info" height="20px" width="20px" />
              <span className="screenreader-only">
                More information about {selected.text}
              </span>
            </Tooltip>

            <PatchLink className="chart-expander" query={expandedParams}>
              <Icon type="expand" height="20px" width="20px" />
              <span className="screenreader-only">Expand chart</span>
            </PatchLink>
          </div>
        </div>

        <div className="chart-container__chart">
          <ChartSwitch
            query={query}
            chart={selected}
            expanded={name === selected.text}
            {...dataProps}
          />
        </div>
      </div>
    )
  }
}

export default withSend(ChartSelector)



// WEBPACK FOOTER //
// ./src/components/chart-selector.js